import clsx from 'clsx';
import {TableEntity} from '~/types/TableEntity';

export function Table({table}: {table: TableEntity}) {
  return (
    <div className="w-full overflow-auto">
      <table className="w-full">
        <tbody>
          {table?.table?.rows?.map((row, rowIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={`row-${rowIndex}`}>
              {row?.cells?.map((cell, cellIndex) => {
                const isColumnHeader =
                  table.firstColumnIsHeader && cellIndex === 0;
                const isRowHeader = table.firstRowIsHeader && rowIndex === 0;
                const isHeader = isColumnHeader || isRowHeader;

                const isNotStripped =
                  !table.columnsStripped && !table.rowsStripped;

                const Component = isHeader ? 'th' : 'td';

                return (
                  <Component
                    // eslint-disable-next-line react/no-array-index-key
                    key={`row-${rowIndex}-cell-${cellIndex}`}
                    className={clsx(
                      'px-3 text-center min-w-[147px]',
                      isHeader
                        ? 'pt-5 pb-4 font-bold text-black bg-gray-200 text-20/27 font-header tracking-wider'
                        : `py-5 text-20/23 ${
                            isNotStripped && 'border-b border-b-gray-300'
                          }`,
                      {
                        'bg-gray-200/50':
                          (table.columnsStripped &&
                            cellIndex % 2 === 1 &&
                            rowIndex !== 0) ||
                          (table.rowsStripped &&
                            rowIndex % 2 === 1 &&
                            (!table.firstColumnIsHeader ||
                              (table.firstColumnIsHeader && cellIndex !== 0))),
                      },
                    )}
                  >
                    {cell}
                  </Component>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
